export default function({ state, commit, dispatch }, assistant) {
    commit('startInvitingAssistant')

    return dispatch('post', {
        url: '/provider/' + state.id + '/assistant',
        data: assistant
    }, {
        root: true
    })
    .then((assistant) => {
        console.log(assistant)
        commit('finishInvitingAssistant')
        commit('addAssistant', assistant)
		return assistant
    })
    .catch((error) => {
        commit('finishInvitingAssistant')
		console.log(error)
		throw error
    })
}
